export default "{\n    \"label\": \"Membresía del cliente\",\n    \"placeholder\": \"Seleccione membresía\"\n}\n"